import { Controller } from "@hotwired/stimulus"

// Choose-all / choose-none for a checkbox group in the same row (or form).
export default class extends Controller {
  static values = { group: String }

  all() {
    this.setChecked(true)
  }

  none() {
    this.setChecked(false)
  }

  setChecked(checked) {
    const scope = this.element.matches("form")
      ? this.element
      : (this.element.closest(".row") || this.element)

    scope.querySelectorAll(`${this.groupValue} input[type="checkbox"]`).forEach((input) => {
      input.checked = checked
    })
  }
}
